import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, HostListener, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { OperadorService } from '@core/services/operador.service';
import { SidebarService } from '@core/services/sidebar.service';
import {
  INotificationEvento,
  INotificationResponse,
} from '@models/INotification';
import { TranslateModule } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { IconComponent } from '@shared/icon/icon.component';
import { AuthService } from '@core/services/auth.service';
import { NotificationsService } from '@core/services/notifications.service';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    NgOptimizedImage,
    TranslateModule,
    IconComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  isMenuOpen = signal(false);
  isMenuNotiOpen = signal(false);
  notifications = signal<INotificationEvento[]>([]);
  totalNotifications = signal(0);

  constructor(
    public sidebarService: SidebarService,
    public router: Router,
    private operadorService: OperadorService,
    private logger: NGXLogger,
    private authService: AuthService,
    private notificationsService: NotificationsService,
  ) {
    this.getNotificaciones();
  }

  toogleMenu() {
    this.isMenuOpen.set(!this.isMenuOpen());
  }

  toogleMenuNoti() {
    this.isMenuNotiOpen.set(!this.isMenuNotiOpen());
  }

  sideBarTooggle() {
    this.sidebarService.sideBarTooggle();
  }

  logOut() {
    this.authService.logoutRequest().subscribe({
      next: () => {
        this.router.navigate(['auth/login']);
      },
      error: (err: any) => {
        this.logger.error('Error during logout', err);
        this.router.navigate(['auth/login']);
      },
    });
  }

  getNotificaciones() {
    this.notificationsService.getHomeNotifications().subscribe({
      next: (r: INotificationResponse) => {
        this.notifications.set(r.items);
        this.totalNotifications.set(r.total);
      },
      error: (err) => {
        console.warn('Error en notificaciones:', err.message);
      },
    });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    // ¿El clic fue dentro del menú o su trigger?
    const insideNoti =
      !!target.closest('.noti-menu') || !!target.closest('.bell-container');
    const insideUser =
      !!target.closest('.user-menu') || !!target.closest('.icon.user');

    if (!insideNoti && this.isMenuNotiOpen()) {
      this.isMenuNotiOpen.set(false);
    }

    if (!insideUser && this.isMenuOpen()) {
      this.isMenuOpen.set(false);
    }
  }
}
